import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { DeviceDeleteEvidenceFieldPathParameters } from 'api/actions/device-delete-evidence-field/device-delete-evidence-field-path-parameters';
import { DeviceDeleteEvidenceFieldResponse } from 'api/actions/device-delete-evidence-field/device-delete-evidence-field-response';

type DeviceDeleteEvidenceFieldQueryParameters = Record<string, any>;

/**
 * The path of the DeviceDeleteEvidenceField action.
 */
export const deviceDeleteEvidenceFieldActionPath = new SweetPath<keyof DeviceDeleteEvidenceFieldPathParameters>(
  '/api/device/evidence-fields/{evidenceFieldId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized DeviceDeleteEvidenceField actions.
 */
export default function createDeviceDeleteEvidenceFieldAction(axios: AxiosInstance) {
  return function deviceDeleteEvidenceFieldAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: DeviceDeleteEvidenceFieldPathParameters;
    query?: DeviceDeleteEvidenceFieldQueryParameters;
  }) {
    const path = deviceDeleteEvidenceFieldActionPath.insert(parameters);

    return axios.request<DeviceDeleteEvidenceFieldResponse, DeviceDeleteEvidenceFieldResponse>({
      method: 'post',
      url: path,
      params: query,

      headers,
    });
  };
}
